import React from "react";
import { useLocation } from "../../../../../../node_modules/react-router-dom/index";
import SimpleBreadcrum from "../../../../../Component/UI/SimpleBreadcrum";
import styles from "../../Feedback/feedback.module.css";
import { Rating } from "./Rating";

export const ViewTestimonial = () => {
  const { state } = useLocation();
  const links = !state?.customerId
    ? [
        {
          path: "/Samvedna/testimonials",
          linkText: "Testimonials",
        },
      ]
    : [
        {
          path: "/Patients",
          linkText: "Patients",
        },
        {
          path: "/patientsProfile",
          linkText: state?.item?.customer?.name,
          data: { name: state?.item?.customer?.name, props: state?.customerId },
        },
      ];
  return (
    <>
      <SimpleBreadcrum text="Testimonials Details" link={links} />
      <div className={styles.details_card}>
        <div>
          <div>
            <p className={styles.sub_heading}>{state?.item?.customer?.name}</p>
            <div className={styles.icons}></div>
          </div>
          {/* <p className={styles.text}>{serviceName}</p> */}
        </div>
        <div>
          <p className={styles.text}>
            <Rating size={40} ratings={state?.item?.rating} />
          </p>
          <p className={styles.sub_heading}>Description</p>
          <p className={styles.text}>{state?.item?.thoughts}</p>
        </div>
      </div>
    </>
  );
};
